var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewer',{staticClass:"wysiwyg-viewer",attrs:{"initialValue":_vm.value,"initialEditType":"markdown"}})}
var staticRenderFns = []

export { render, staticRenderFns }